/*
 * push-notification-message (schema)
 */
import { boolean, jsonb, timestamp, uuid, varchar } from "drizzle-orm/pg-core"
import { schema } from "../../constants"
import { users } from "../../user/user.schema"
import { pushNotificationSubscriptions } from "../push-notification-subscription/push-notification-subscription.schema"

export const pushNotificationMessages = schema.table(
	"push_notification_messages",
	{
		id: uuid("id").primaryKey().notNull().defaultRandom(),
		userId: uuid("user_id").references(() => users.id, {
			onDelete: "cascade",
		}),
		subscriptionIds: uuid("subscription_ids")
			.references(() => pushNotificationSubscriptions.id, {
				onDelete: "set null",
			})
			.array(),
		eventId: uuid("event_id"),
		eventType: varchar("event_type").notNull(),
		title: varchar("title").notNull(),
		body: varchar("body").notNull(),
		url: varchar("url"),
		data: jsonb("data"),
		response: varchar("response"),
		status: varchar("status").notNull().default("pending"),
		/* System */
		active: boolean("active").notNull().default(true),
		createdAt: timestamp("created_at").notNull().defaultNow(),
		updatedAt: timestamp("updated_at").notNull().defaultNow(),
		createdBy: uuid("created_by").references(() => users.id, {
			onDelete: "set null",
		}),
		updatedBy: uuid("updated_by").references(() => users.id, {
			onDelete: "set null",
		}),
	},
)
